import { useRoom } from '@daily-co/daily-react'
import { usePatientConnected } from './usePatientConnected'
import { useProviderConnected } from './useProviderConnected'

export function useCallIsActive() {
  const room = useRoom()
  const { patientConnected } = usePatientConnected()
  const { providerConnected } = useProviderConnected()
  const callIsActive = !!(room && patientConnected && providerConnected)

  return { callIsActive }
}
